import React from 'react';
import { Title, Button, ButtonsGroup } from 'components/commons';
import clockIcon from 'assets/svg/speed-clock.svg';

type RecentlyDeniedLayoutProps = {
    daysLeft: number;
    onOk(): void;
}

const RecentlyDeniedLayout: React.FC<RecentlyDeniedLayoutProps> = ({ daysLeft, onOk }) => (
    <div className="message-box-container">
        <div className="inner">
            <div className="screen">
                <div className="message-box message-box__recently-denied text-left">
                    <img className="icon clock-icon" src={clockIcon} />
                    <Title>
                        seu pedido é recente
                    </Title>
                    <p className="text">
                        <b>Aguarde {daysLeft} dias</b> para fazer uma nova análise <br className="hidden-sm" />
                        e conferir as condições de crédito para a sua empresa
                    </p>
                    <p className="text mt-2">
                        Ficou com dúvida?  <a href='https://bizcapital.com.br/central-de-ajuda/por-que-recebi-a-mensagem-que-preciso-esperar-90-dias-para-solicitar-um-novo-emprestimo/' target='_blank' >saiba mais.</a>
                    </p>
                </div>
                <ButtonsGroup align="left">
                    <Button label="concluir" onClick={onOk} />
                </ButtonsGroup>
            </div>
        </div>
    </div>
);

export default RecentlyDeniedLayout;
